exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":0,"alias":{"/assets":"/home/vintagp/www/toyota_dreamcar/front/assets","/static":"/home/vintagp/www/toyota_dreamcar/front/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64b4760d","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/_UI/BaseExternalLink.vue
// module id = 0hdz
// module chunks = 13